import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'

type ReportPaginationProps = {
  page: number
  pageCount: number
  onPage: (page: number) => void
}

const ReportPagination = ({ page, pageCount, onPage }: ReportPaginationProps) => {
  const total = Math.max(1, Number(pageCount) || 1)
  const current = Math.min(Math.max(Number(page) || 1, 1), total)
  const [gotoPage, setGotoPage] = useState(String(current))
  const isFirst = current <= 1
  const isLast = current >= total

  useEffect(() => {
    setGotoPage(String(current))
  }, [current])

  const go = (next: number) => {
    const clamped = Math.min(Math.max(next, 1), total)
    if (clamped === current) return
    onPage(clamped)
  }

  const submitGoto = () => {
    const next = parseInt(gotoPage, 10)
    if (Number.isNaN(next)) {
      setGotoPage(String(current))
      return
    }
    go(next)
  }

  const handleGotoKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      submitGoto()
    }
  }

  const handleGotoChange = (event: ChangeEvent<HTMLInputElement>) => {
    setGotoPage(event.target.value)
  }

  return (
    <div className='custom-pagination mt-2'>
      <div
        className={isFirst ? 'disabled' : ''}
        aria-disabled={isFirst}
        onClick={() => !isFirst && go(1)}
      >
        First
      </div>
      <div
        className={isFirst ? 'disabled' : ''}
        aria-disabled={isFirst}
        onClick={() => !isFirst && go(current - 1)}
      >
        Previous
      </div>
      <div
        className={isLast ? 'disabled' : ''}
        aria-disabled={isLast}
        onClick={() => !isLast && go(current + 1)}
      >
        Next
      </div>
      <div
        className={isLast ? 'disabled' : ''}
        aria-disabled={isLast}
        onClick={() => !isLast && go(total)}
      >
        Last
      </div>
      <div>
        <span className='me-2'>
          Page{' '}
          <b>
            {current} of {total}
          </b>
        </span>
        <span className='me-2'>| Go to Page</span>
        <input
          className='form-control'
          type='number'
          min={1}
          max={total}
          value={gotoPage}
          onChange={handleGotoChange}
          onBlur={submitGoto}
          onKeyDown={handleGotoKeyDown}
        />
      </div>
    </div>
  )
}

export default ReportPagination
